import styled from "styled-components";
import { fieldStyles } from "./ui";

const TextArea = ({ placeholder, name, setPayload }) => {
  return (
    <Area
      id = { name }
      aria-label = { placeholder }
      name = { name }
      rows = { 4 }
      onChange= { e => { handleChange(e, setPayload) } }
    ></Area>
  );
};

const handleChange = (e, setPayload) => {
  setPayload(e.target.name, e.target.value);
}

const Area = styled.textarea`
  ${fieldStyles}
  margin-bottom: 16px;
  resize: vertical;
  min-height: 112px;
`;

export default TextArea;
